import { ListeCarteImageNom, ListeCarteImageNomContext } from '@components/liste-carte-image-nom/models';
import { Block } from '@shared/models';

export const listeCarteImageNomMock = (
  context: ListeCarteImageNomContext,
  isLarge = false
): Block<ListeCarteImageNom> => ({
  type: 'liste-carte-image-nom',
  data: { context, isLarge },
});
